<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="#888888" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.9857 16L4 15.0143L9.0143 10L4 4.9857L4.9857 4L10 9.0143L15.0143 4L16 4.9857L10.9857 10L16 15.0143L15.0143 16L10 10.9857L4.9857 16Z" />
  </svg>
</template>